import { ControlPanel, StockDocumentListing } from "./control"
import { DocumentTypesEdit, DocumentTypesSelection } from "./documentTypes"
import { LocationListing } from "./location"
import { SettingsCostMethod, SettingsEnableModule } from "./settings"

export const DocumentTypesEditSection = DocumentTypesEdit
export const DocumentTypesSelectionSection = DocumentTypesSelection
export const LocationListingSection = LocationListing
export const SettingsCostMethodSection = SettingsCostMethod
export const SettingsEnableModuleSection = SettingsEnableModule
export const ControlPanelSection = ControlPanel
export const StockDocumentListingSection = StockDocumentListing





// WEBPACK FOOTER //
// ./src/inventory/sections/index.ts